module.exports = __webpack_public_path__ + "static/media/tien.2ffd358b.jpg";